( function( $, window ) {
    'use strict';

    $( function() {
        var matchMedia = window.matchMedia( '(max-width: 767px)' );

        function handleShowMore() {
            const $trigger      = $( '.js-show-more-trigger' );
            const $target       = $( '.js-show-more-target' );
            const $label        = $( '.js-show-more-label' );
            const activeClass   = 'is-active';
            const slideDuration = 300;

            if ( ! matchMedia.matches ) {
                return;
            }

            $trigger.unbind( 'click' ).on( 'click', function() {
                const isActive          = $( this ).hasClass( activeClass );
                const $targetElement    = $( this ).parents().find( $target );

                if ( isActive ) {
                    $( this ).removeClass( activeClass );
                    $targetElement.removeClass( activeClass ).stop().slideUp( slideDuration, function() {
                        $( this ).css( 'display', '' );
                    } );
                    $label.text( 'Show more' );
                } else {
                    $( this ).addClass( activeClass );
                    $targetElement.addClass( activeClass ).css( 'display', 'flex' ).hide().stop().slideDown( slideDuration );
                    $label.text( 'Show less' );
                }
            } );
        }

        handleShowMore();

        matchMedia.addEventListener( 'change', handleShowMore );
    } );
} )( jQuery, window );
